import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import {LanguagesInt} from '@interfaces/';
import { GlobalsService } from '@app/services/micro/globals.service';
import { UrlService } from '@app/services/url.service';
import { Ga4Service } from '@app/services/ga4.service';
import { KioskPropertiesGA4Int } from '@app/interfaces/ga4.interface';
/**
  Componente para mostrar un modal de selección de idiomas.
  Este componente permite abrir un modal con opciones configurables,
  como deshabilitar el cierre al hacer clic fuera del modal o presionar la tecla ESC.
  Además, gestiona el resultado del cierre del modal y proporciona una razón de cierre.
  También permite seleccionar un idioma y enviar eventos de seguimiento a GA4.
**/
@Component({
    selector: 'app-languages-modal',
    templateUrl: './languages-modal.component.html',
    styleUrls: ['./languages-modal.component.scss'],
    standalone: false
})
export class LanguagesModalComponent implements OnInit {
  /**
    Opciones de configuración del modal.
    - backdrop: 'static' evita que el modal se cierre al hacer clic fuera de él.
    - keyboard: false deshabilita el cierre del modal al presionar la tecla ESC.
  **/
  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
    /**
    Almacena el resultado del cierre del modal.
  **/
  closeResult = '';

  constructor(
    private modalService: NgbModal,
    public modal: NgbActiveModal,
    private _globalService: GlobalsService,
    private _urlService: UrlService,
    private _ga4Service: Ga4Service
  ) { }

  ngOnInit(): void {
    const userPropertiesModal: KioskPropertiesGA4Int = {
      page_location: this._urlService.currentUrl || '/home',
      page_referrer: this._urlService.beforeUrl,
      screen_resolution: '1280x1024',
      sub_funnel_name: 'languages'
    };

    this._ga4Service.sendKioskPropertiesEvent(userPropertiesModal);
  }
  /**
    Abre un modal con el contenido proporcionado.
    @param content Contenido que se mostrará dentro del modal.
    @return void - No retorna ningún valor, pero actualiza `closeResult` con el resultado del cierre.
  **/
  open(content: any): void {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
/**
    Maneja la selección de un idioma.
    - Actualiza el idioma seleccionado en el servicio global.
    - Cierra el modal.
    @param select Objeto que representa el idioma seleccionado.
    @return void - No retorna ningún valor.
  **/
  onSelected(select: LanguagesInt): void {
    const {id} = select;
    this._globalService.languageSelected = select;
    this._globalService.language$.next(id.replace("-", "_"))
    this.modal.close()
  }
  /**
    Obtiene la razón por la cual se cerró el modal.
    @param reason Razón del cierre del modal.
    @return string - Retorna una cadena que describe la razón del cierre.
  **/
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
